import React, { useContext, useState, useEffect } from "react";
// import "./CreatProject.css";
import Application from "../../../StateContext/Application.js";
import CustomDateTimePicker from "../../ProjectManagement/CustomDateTimePicker.jsx";

import {
  ProjectCreation64,
  BudgetHeadCreationBlue32,
  Cancel32,
  DeleteRed32,
  EditBlueBlue32,
  submit,
  Tax32,
  UpdateWhite32,
  EditIcon,
  DeleteIcon,
  Edit32WHITE,
  Delete32WHITE,
} from "../../../../../public/LoginImages/importimages";

// 21-10
const FIELD_LABELS = {
  AgencyName: "Agency Name",
  Date: "Date",
  Village: "Building/Village Details",
  Road: "Road/Street/Post Office",
  Area: "Area/Locality",
  City: "City",
  State: "State",
  District: "District",
  PinCode: "Pin Code",
  ContactPerson: "Contact Person",
  Designation: "Designation",
  PhoneNo: "Phone Number",
  AlternamePhoneNo: "Alternate Phone Number",
  MobileNo: "Mobile Number",
  Email: "Email",
  Username: "Username",
};
 
const FIELDS = [
  { name: "AgencyName", label: "Agency Name", placeholder: "Enter Agency Name" },
  { name: "Date", label: "Date", type: "datetime-local" },
  {
    name: "Village",
    label: "Block no/Building/Village/Name of Premises",
    placeholder: "Enter Details",
  },
  { name: "Road", label: "Road/Street/Post Office", placeholder: "Enter Details" },
  { name: "Area", label: "Area/Locality", placeholder: "Enter Details" },
  { name: "City", label: "City", placeholder: "Enter City" },
  { name: "State", label: "State", placeholder: "Enter State" },
  { name: "District", label: "District", placeholder: "Enter District" },
  {
    name: "PinCode",
    label: "Pin Code",
    placeholder: "Enter Pin Code",
    inputMode: "numeric",
    maxLength: 6,
  },
  {
    name: "ContactPerson",
    label: "Contact Person",
    placeholder: "Enter Contact Person",
  },
  { name: "Designation", label: "Designation", placeholder: "Enter Designation" },
  {
    name: "PhoneNo",
    label: "Phone No",
    placeholder: "Enter Phone No",
    inputMode: "numeric",
    maxLength: 10,
  },
  {
    name: "AlternamePhoneNo",
    label: "Altername Phone No",
    placeholder: "Enter Altername Phone No",
    inputMode: "numeric",
    maxLength: 10,
  },
  {
    name: "MobileNo",
    label: "Mobile No",
    placeholder: "Enter Mobile No",
    inputMode: "numeric",
    maxLength: 10,
  },
  { name: "Email", label: "Email", placeholder: "Enter Email", type: "email" },
  { name: "Username", label: "Username", placeholder: "Enter Username" },
];
 
const ErrorText = ({ msg }) =>
  msg ? (
    <span style={{ color: "red", fontSize: "13px", marginTop: "5px" }}>
      {msg}
    </span>
  ) : null;
 


  const inputStyle = (hasError) => ({
  border: hasError ? "1px solid red" : "1px solid #ccc",
  borderRadius: "5px",
  padding: "10px",
  width: "90%",
});
 
const toLocalInput = (value) => {
  if (!value) return "";
  const d = new Date(value);
  if (isNaN(d.getTime())) return "";
  const p = (n) => String(n).padStart(2, "0");
  return `${d.getFullYear()}-${p(d.getMonth() + 1)}-${p(d.getDate())}T${p(
    d.getHours()
  )}:${p(d.getMinutes())}`;
};
 
const validateField = (name, value) => {
  const label = FIELD_LABELS[name];
  if (!label) return "";
  return String(value ?? "").trim() ? "" : `${label} is required.`;
};
 
//  ----


const CreateAgency = () => {
  const operation = useContext(Application);
  const { AgencyRegistration,GetAllAgencyUsers } = operation; //06-10

  const [data, setData] = useState({
    AgencyName: "",
    Date: "",
    Village: "",
    Road: "",
    Area: "",
    City: "",
    State: "",
    District: "",
    PinCode: "",
    ContactPerson: "",
    Designation: "",
    PhoneNo: "",
    AlternamePhoneNo: "",
    MobileNo: "",
    Email: "",
    UniqueAgencyCode: "",
    Username: "",
  });

  const [loading, setLoading] = useState(false);

  // 06-10
  const [emailError, setEmailError] = useState("");
const [usernameError, setUsernameError] = useState("");
const [agencyList, setAgencyList] = useState([]);
  const [errors, setErrors] = useState({});//21-10
 
useEffect(() => {
  const loadUsers = async () => {
    try {
      const list = await GetAllAgencyUsers();
      console.log("Users list for duplicate check:", list);
      setAgencyList(Array.isArray(list) ? list : []);
    } catch (err) {
      console.error("Users list error:", err);
    }
  };
  loadUsers();
}, []);
 
const isEmailTaken = (email) =>
  agencyList.some(
    (a) => a.Email?.trim().toLowerCase() === email.trim().toLowerCase()
  );
 
const isUsernameTaken = (username) =>
  agencyList.some(
    (a) => a.Username?.trim().toLowerCase() === username.trim().toLowerCase()
  );
 
//  21-10
    const labelStyle = {  fontWeight: "700", marginBottom: "7px" ,fontSize:"14px",lineHeight:"20px" };
  const colStyle = { display: "flex", flexDirection: "column" };
 
//  ------------

  const HandleChangeData = (e) => {
    const { name, value } = e.target;
    let sanitizedValue = value;
    // ---- Input-time restrictions ----
    if (name === "PinCode") {
      sanitizedValue = value.replace(/\D/g, "").slice(0, 6); // digits only, max 6
    } else if (name === "Designation") {
      sanitizedValue = value.replace(/[^A-Za-z\s]/g, ""); // no numbers allowed
    } else if (name === "PhoneNo" || name === "AlternamePhoneNo") {
      sanitizedValue = value.replace(/\D/g, "").slice(0, 10); // digits only, max 10
    } else if (name === "MobileNo") {
      sanitizedValue = value.replace(/\D/g, "").slice(0, 10); // digits only, max 10
    }


// 06-10
if (name === "Email") {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
 
  if (sanitizedValue.length > 0 && !emailRegex.test(sanitizedValue)) {
    setEmailError("Please enter a correct email address.");
  } else if (sanitizedValue.length > 0 && isEmailTaken(sanitizedValue)) {
    setEmailError("This email is already in use.");
    alert("This email is already in use.");
  } else {
    setEmailError("");
  }
}
 
if (name === "Username") {
  if (sanitizedValue.length > 0 && isUsernameTaken(sanitizedValue)) {
    setUsernameError("This username is already taken.");
    alert("This username is already taken.");
  } else {
    setUsernameError("");
  }
}
// -----------

    let updatedData = { ...data, [name]: value };
    if (name === "AgencyName") {
      if (value.trim() === "") {
        updatedData.UniqueAgencyCode = "";
      } else {
        const prefix = value.replace(/\s+/g, "").slice(0, 3).toUpperCase();
        const uniqueNumber = Date.now().toString().slice(-6);
        updatedData.UniqueAgencyCode = `AG${prefix}${uniqueNumber}`;
      }
    }

    setData(updatedData);
  };
  
// inside CreateAgency, below HandleChangeData
const handleDatePart = (part, val) => {
  const [curDate = "", curTime = ""] = toLocalInput(data.Date).split("T");
  const nextDate = part === "date" ? val : curDate;

  if (!nextDate) {
    HandleChangeData({ target: { name: "Date", value: "" } });
    setErrors((prev) => ({ ...prev, Date: "" }));
    return;
  }

  const nextTime =
    part === "time"
      ? val
      : curTime || toLocalInput(new Date()).split("T")[1];

  HandleChangeData({
    target: { name: "Date", value: `${nextDate}T${nextTime || "00:00"}` },
  });
  setErrors((prev) => ({ ...prev, Date: "" }));
};
// 27-10 for cal
const handleDateTimeChange = (e) => {
  const input = e.target;
  const value = input.value;

  const prevDate = toLocalInput(data.Date).split("T")[0];
  const newDate = (value || "").split("T")[0];

  HandleChangeData({ target: { name: "Date", value } });
  setErrors((prev) => ({ ...prev, Date: "" }));

  // Close the calendar only when the DATE changed, not when only time changed
  if (newDate !== prevDate) {
    setTimeout(() => input.blur(), 0);
  }
};


const handleSubmit = async (e) => {

  e.preventDefault();

  if (loading) return;
 
  const newErrors = {};

  Object.keys(FIELD_LABELS).forEach((key) => {

    const msg = validateField(key, data[key]);

    if (msg) newErrors[key] = msg;

  });
 
  if (!data.UniqueAgencyCode.trim() && !newErrors.AgencyName) {

    newErrors.AgencyName = "Agency Name is required to generate Agency Code.";

  }
 
  setErrors(newErrors);
 
  const firstKey = Object.keys(newErrors)[0];

  if (firstKey) {

    document.querySelector(`[name="${firstKey}"]`)?.focus();

    return;

  }
 
  setLoading(true);

  try {

    const result = await AgencyRegistration(data);

    if (result?.message) {

      alert(result.message);

      if (result?.success) window.location.reload();

    }

  } catch (err) {

    console.error("Agency Registration Error:", err);

    alert("Something went wrong while registering the agency.");

  } finally {

    setLoading(false);

  }

};
 
// ----
//    const toLocalInput = (value) => {
//   if (!value) return "";
 
//   const d = new Date(value);
 
//   if (isNaN(d.getTime())) return "";
 
//   const p = (n) => String(n).padStart(2, "0");
 
//   return `${d.getFullYear()}-${p(d.getMonth() + 1)}-${p(
//     d.getDate()
//   )}T${p(d.getHours())}:${p(d.getMinutes())}`;
// };
  return (
    <>
      <div
        style={{
          background: "white",
          maxHeight: "92vh",
          transition: "margin-left 0.3s ease",
          overflowY: "auto",
          msOverflowStyle: "none",
          scrollbarWidth: "none",
          padding: 40,
          fontFamily: "Inter, sans-serif",
        }}
      >
        <div
          style={{
            display: "flex",
          marginLeft:"20px",
            width: "auto",
            marginBottom: "20px",
            paddingRight: "70px",
          }}
        >
          <img
            src={ProjectCreation64}
            style={{
              marginRight: "5px",
              color: "#044c92",
              fontSize: "18px",
              height: "25px",
            }}
          ></img>
          <h5
            style={{
              margin: 0,
              color: "#044c92",
              fontWeight: 700,
              fontSize: "22px",
            }}
          >
            Agency Registration
          </h5>
        </div>

        <form onSubmit={handleSubmit} noValidate
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            backgroundColor: "#ffffff",
            boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
            borderRadius: "10px",
            padding: "20px",
            //30/10
            maxWidth: "950px",
            margin: "0 auto",
          }}
        >
          <div
            style={{
              width: "100%",
              maxWidth: "1000px",
              //30/10
              backgroundColor: "#EEF1F6",
              boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
              borderRadius: "20px",
              padding: "60px",
            }}
          >
            <div
              style={{
                display: "grid",
                gap: "20px",
                width: "100%",
                gridTemplateColumns: "1fr 1fr",
              }}
            >
{/* 21-10 */}
{/* {FIELDS.map((f) => {
              const isDate = f.type === "datetime-local";
              return (
                <div key={f.name} style={colStyle}>
                  <label className="form-label" style={labelStyle}>
                    {f.label}
                  </label>
                  <input
                    type={f.type || "text"}
                    name={f.name}
                    placeholder={f.placeholder}
                    inputMode={f.inputMode}
                    maxLength={f.maxLength}
                    className="form-control py-2"
                    value={isDate ? toLocalInput(data.Date) : data[f.name]}
                    onChange={(e) => {
                      HandleChangeData(e);
                      if (isDate) e.target.blur();
                    }}
                    style={{
                      ...inputStyle(!!errors[f.name]),
                      ...(isDate && {
                        height: "40px",
                        fontSize: "13px",
                        boxSizing: "border-box",
                      }),
                    }}
                  />
                  <ErrorText msg={errors[f.name]} />
                </div>
              );
            })} */}
            {/* 24-10 for cal */}
            {FIELDS.map((f) => {
  const isDate = f.type === "datetime-local";
  return (
    <div key={f.name} style={colStyle}>
      <label className="form-label" style={labelStyle}>
        {f.label}
      </label>

     {isDate ? (
  <input
    type="datetime-local"
    name="Date"
    className="form-control py-2"
    value={toLocalInput(data.Date)}
    max="9999-12-31T23:59"
    onChange={handleDateTimeChange}
    style={{
      ...inputStyle(!!errors.Date),
      height: "40px",
      fontSize: "13px",
      boxSizing: "border-box",
    }}
  />
) : (
  <input
    type={f.type || "text"}
    name={f.name}
    placeholder={f.placeholder}
    inputMode={f.inputMode}
    maxLength={f.maxLength}
    className="form-control py-2"
    value={data[f.name]}
    onChange={HandleChangeData}
    style={inputStyle(!!errors[f.name])}
  />
)}
      <ErrorText msg={errors[f.name]} />
    </div>
  );
})}
 {/* ---------- */}

             
              <div style={{ display: "flex", flexDirection: "column" }}>
                <label
                  className="form-label"
                  style={{fontWeight: "700", marginBottom: "7px" ,fontSize:"14px",lineHeight:"20px" }}
                >
                  Unique Agency Code
                </label>
                <input
                  type="text"
                  placeholder="Enter Unique Agency Code"
                  className="form-control py-2"
                  name="UniqueAgencyCode"
                  value={data.UniqueAgencyCode}
                  onChange={HandleChangeData}
                  style={{
                    border: "1px solid #ccc",
                    borderRadius: "5px",
                    padding: "10px",
                    width: "90%",
                  }}
                  required
                  disabled
                />
              </div>
            </div>
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                gap: "20px",
                marginTop: "20px",
                marginRight: "60px",
              }}
            >
              <button
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  borderRadius: "20px",
                  width: "120px",
                  height: "40px",
                  backgroundColor: "#39b54a",
                  border: "none",
                  fontSize: "16px",
                  color: "#ffffff",
                  fontWeight: "700",
                }}
                onClick={handleSubmit}
              >
                {/* <img
                  src={submit}
                  style={{
                    marginRight: "10px",
                    width: "1.2rem",
                    paddingBottom: "3px",
                    fontSize: "15px",
                  }}
                />
                Save */}
                {/* 28-09 add loader */}
                   {loading ? (
    <>
      <span
        style={{
          width: "16px",
          height: "16px",
          border: "2px solid rgba(255,255,255,0.4)",
          borderTop: "2px solid #ffffff",
          borderRadius: "50%",
          display: "inline-block",
          animation: "spin 0.7s linear infinite",
          marginRight: "8px",
        }}
      ></span>
      Saving...
    </>
  ) : (
    <>
      <img
        src={submit}
        style={{
          marginRight: "10px",
          width: "1.2rem",
          paddingBottom: "3px",
        }}
      />
      Save
    </>
  )}
              </button>
              <button
                type="button"
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  borderRadius: "20px",
                  width: "120px",
                  height: "40px",
                  backgroundColor: "#b9291c",

                  border: "none",
                  fontSize: "16px",
                  color: "#ffffff",
                  fontWeight: "700",
                }}
                onClick={() => window.location.reload()}
              >
                <img
                  src={Cancel32}
                  style={{ marginRight: "10px", width: "1.2rem" }}
                />
                Cancel
              </button>
            </div>
          </div>
        </form>
      </div>
    </>
  );
};

export default CreateAgency;
